import React from 'react';

export type ToolId =
  | 'overlays' | 'basemap' | 'airports' | 'weather' | 'airspace'
  | 'filter' | 'bookmarks' | 'drawing' | 'terrain' | 'coordinates'
  | 'measure' | 'tracklog' | 'settings' | 'plates'
  | 'flightplan' | 'navlog' | 'export' | 'planlist' | 'login' | 'review' | 'threeD'
  | 'spatial' | 'download';

interface ToolDef { id: ToolId; icon: string; label: string; }

const TOOLS: ToolDef[] = [
  { id: 'flightplan', icon: '✈️', label: 'Plan' },
  { id: 'navlog',     icon: '📋', label: 'NavLog' },
  { id: 'planlist',   icon: '📂', label: 'Plans' },
  { id: 'export',     icon: '📤', label: 'Export' },
  { id: 'overlays',    icon: '🗺️', label: 'Layers' },
  { id: 'basemap',     icon: '🌐', label: 'Base' },
  { id: 'airports',    icon: '🛬', label: 'Airports' },
  { id: 'weather',     icon: '⛅', label: 'Wx' },
  { id: 'airspace',    icon: '🔷', label: 'Airsp' },
  { id: 'plates',      icon: '📑', label: 'Plates' },
  { id: 'filter',      icon: '🔎', label: 'CQL' },
  { id: 'bookmarks',   icon: '📌', label: 'Marks' },
  { id: 'drawing',     icon: '✏️', label: 'Draw' },
  { id: 'terrain',     icon: '⛰️', label: 'Terr' },
  { id: 'coordinates', icon: '📐', label: 'Coord' },
  { id: 'measure',     icon: '📏', label: 'Meas' },
  { id: 'tracklog',    icon: '⏺️', label: 'Track' },
  { id: 'settings',    icon: '⚙️', label: 'Setup' },
  { id: 'login',       icon: '🔐', label: 'Auth' },
  { id: 'review',      icon: '🎬', label: 'Review' },
  { id: 'spatial',     icon: '▦', label: 'Spatial' },
  { id: 'download',    icon: '⬇️', label: 'Download' },
  { id: 'threeD',      icon: '🌍', label: '3D' },
];

interface ToolbarProps {
  activeTool: ToolId | null;
  onSelect: (tool: ToolId) => void;
}

export const Toolbar: React.FC<ToolbarProps> = ({ activeTool, onSelect }) => (
  <nav className="toolbar" role="toolbar" aria-label="Map tools">
    {TOOLS.map((t) => (
      <button
        key={t.id}
        className={`toolbar-btn ${activeTool === t.id ? 'active' : ''}`}
        onClick={() => onSelect(t.id)}
        title={t.label}
        aria-pressed={activeTool === t.id}
      >
        <span>{t.icon}</span>
        <span className="toolbar-btn-label">{t.label}</span>
      </button>
    ))}
  </nav>
);
